import React from "react";
import styled from "styled-components";

interface TeamRelationshipCardProps {
  onClick: () => void;
  staff: boolean;
  icon: React.ReactNode;
  text: string;
  selected: boolean;
  style?: React.CSSProperties;
}

const StyledTeamRelationshipCard = styled.div.attrs({ className: "team-relationship-card" })<{
  staff: boolean;
  selected: boolean;
}>`
  display: flex;
  flex-direction: column;
  background-color: ${({ selected }) => (selected ? '#36383D' : '#fafafa')};
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(54, 56, 61, 0.2);
  height: ${({ staff }) => (staff ? '144px' : '104px')};
  cursor: pointer;
  width: 100%;

  .content {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 12px;
  }

  .icon {
    line-height: normal;
  }

  .text {
    color: ${({ selected }) => (selected ? '#fafafa' : '#36383D')};
    font-family: Rubik;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-left: 12px;
  }
`;

const TeamRelationshipCard: React.FC<TeamRelationshipCardProps> = ({ onClick, staff, icon, selected, text, style }) => (
  <StyledTeamRelationshipCard onClick={onClick} staff={staff} selected={selected} style={style}>
    <div className="content">
      <div className="icon">{icon}</div>
      <div className="text">{text}</div>
    </div>
  </StyledTeamRelationshipCard>
);

export default TeamRelationshipCard;
